// Mirrors SortBy.adjustSelections — the available sort options depend on
// the current buying_format, relevancy flag, and custom_sort_enabled flag.
//
// Returns [[code, label], ...] in display order. The code uses the
// `${sort_field}:${sort_direction}` form expected by `filters.sort_by.query.code`.

export default function getSortOptions(model) {
  const filters = model.filters || {}
  const bfCode = (filters.buying_format && filters.buying_format.code) || ''

  let selections
  if (bfCode === 'Buy It Now') {
    selections = [
      ['close_date:asc', 'Closing Next'],
      ['open_date:desc', 'Newly Added'],
      ['current_price:desc', 'Sale price (high to low)'],
      ['current_price:asc', 'Sale price (low to high)'],
    ]
    if (!model.hide_qty_sort) {
      selections.push(['quantity:desc', 'Quantity (high to low)'])
      selections.push(['quantity:asc', 'Quantity (low to high)'])
    }
  } else {
    // Auction (default) or All
    selections = [
      ['close_date:asc', 'Closing Next'],
      ['open_date:desc', 'Newly Added'],
      ['bid_count:desc', 'Bid Count (high to low)'],
      ['bid_count:asc', 'Bid Count (low to high)'],
      // Sorts on the price the card shows — next bid for auctions, sale price
      // for BIN — so "Price" rather than "Current price" (DEV-2639).
      ['current_price:desc', 'Price (high to low)'],
      ['current_price:asc', 'Price (low to high)'],
    ]
  }

  // "Best Content" and "Relevancy" intentionally dropped per DEV-1774 scope.
  // "Featured" stays — only appears when custom_sort_enabled (curated pages).
  if (filters.custom_sort_enabled) {
    selections.unshift(['pos:asc', 'Featured'])
  }

  return selections
}

export function labelForCode(model, code) {
  const opts = getSortOptions(model)
  const found = opts.find(([c]) => c === code)
  return found ? found[1] : (opts[0] && opts[0][1]) || ''
}
